import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource);
Vue.http.options.credentials = true;


// WEBPACK FOOTER //
// ./src/store/actions.js